class HorizontalFullWidthSlider extends HTMLElement {
  constructor() {
    super();
    this.animationProgress = 0; 
    this.visualState = 'hero'; 
    this.isAnimating = false;
    this.canLock = true;
    this.isLocked = false;
    this.lastLockScrollY = 0;
  }

  connectedCallback() {
    this.track = this.parentElement;
    this.fullImagesContainer = this.querySelector('.horizontal-full-screen-slider__full-images');
    this.initSwiper();
    this.initArrows();

    if (this.fullImagesContainer) {
      this.fullImagesContainer.classList.add('is-full-view');
      this.visualState = 'hero';
    }

    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  initArrows() {
    this.prevBtn = this.querySelector('.left-arrow');
    this.nextBtn = this.querySelector('.right-arrow');
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.swiper.slidePrev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.swiper.slideNext());
    this.swiper.on('slideChange', () => this.updateArrowStates());
    this.updateArrowStates();
  }

  updateArrowStates() {
    if (this.prevBtn) this.prevBtn.disabled = this.swiper.isBeginning;
    if (this.nextBtn) this.nextBtn.disabled = this.swiper.isEnd;
  }
  
  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      loop: false,
      direction: 'horizontal',
      slidesPerView: 'auto',
      centeredSlides: true,
      // loop: true,
      slideToClickedSlide: true,
      spaceBetween: 10,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      autoHeight: true,
      breakpoints: {
        768: {
          spaceBetween: 20,
          autoHeight: false
        },
        992: {
          mousewheel: {
            sensitivity: 1,
            thresholdDelta: 20
          },
          autoHeight: false
        }
      }
    });
  }

  // --- Animation Logic ---
  animateTo(state) {
    if (state === this.visualState) return;
    this.isAnimating = true;

    if (state === 'slider') {
        const pos = this.getSlideImagePosition();
        if (pos) {
          this.fullImagesContainer.classList.remove('is-full-view');
          this.fullImagesContainer.style.top = `${pos.top}px`;
          this.fullImagesContainer.style.right = `${pos.right}px`;
          this.fullImagesContainer.style.bottom = `${pos.bottom}px`;
          this.fullImagesContainer.style.left = `${pos.left}px`;
        }
        this.visualState = 'slider';

    } else {
        const pos = this.getSlideImagePosition();
        if (pos) {
          this.fullImagesContainer.style.top = `${pos.top}px`;
          this.fullImagesContainer.style.right = `${pos.right}px`;
          this.fullImagesContainer.style.bottom = `${pos.bottom}px`;
          this.fullImagesContainer.style.left = `${pos.left}px`;
          
          this.fullImagesContainer.offsetHeight;
        }

        this.fullImagesContainer.classList.add('is-full-view');
        this.fullImagesContainer.style.top = '';
        this.fullImagesContainer.style.right = '';
        this.fullImagesContainer.style.bottom = '';
        this.fullImagesContainer.style.left = '';
        
        this.visualState = 'hero';
    }

    setTimeout(() => {
      this.isAnimating = false;
    }, 500); 
  }

  handleScroll() {
    if (window.innerWidth < 992) return;

    if (!this.canLock) {
      if (Math.abs(window.scrollY - this.lastLockScrollY) > 100) {
        this.canLock = true;
      }
    }

    if (this.isLocked || !this.canLock) return;

    const rect = this.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const elementCenter = rect.top + rect.height / 2;
    const viewportCenter = viewportHeight / 2;
    
    if (Math.abs(elementCenter - viewportCenter) < 20) {
      this.performCenterLock();
    }
  }

  performCenterLock() {
    this.isLocked = true;
    this.canLock = false;

    document.body.style.overflow = 'hidden';
    this.scrollIntoView({ block: 'center', behavior: 'auto' });

    setTimeout(() => {
      document.body.style.overflow = '';
      this.isLocked = false;
      this.lastLockScrollY = window.scrollY;
    }, 1000);
  }

  getSlideImagePosition() {
    if (!this.swiper) return null;
    
    const activeSlide = this.swiper.slides[this.swiper.activeIndex];
    if (!activeSlide) return null;
    
    const staticImg = activeSlide.querySelector('.horizontal-full-screen-slider__static-image');
    if (!staticImg) return null;

    const myRect = this.getBoundingClientRect();
    const imgRect = staticImg.getBoundingClientRect();

    const top = imgRect.top - myRect.top;
    const left = imgRect.left - myRect.left;
    const right = myRect.width - (left + imgRect.width);
    const bottom = myRect.height - (top + imgRect.height);

    return { top, right, bottom, left };
  }

}

customElements.define('horizontal-full-width-slider', HorizontalFullWidthSlider);
